export default "__VITE_ASSET__CqEVz$Or__"